/**
 * splitTime splits a string presented time like XX:XX into array of Numbers
 * @param s {String} expects string of the type XX:XX
 * @returns number[]
 */
export var splitTime = function (s) { return s.split(":").map(function (x) { return parseInt(x); }); };
//# sourceMappingURL=SplitTime.js.map